
import { Component, Vue, Prop } from 'vue-property-decorator';
import LoanContainer from './LoanContainer.vue';
@Component({
  components: {
    LoanContainer,
  },
})
export default class EmailVerification extends Vue {
  @Prop({ default: false }) private isPhoneVerified!: boolean;
  private skipEmailVerification() {
    this.$emit('skip-email-login');
  }
}
